// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Radio_wrapper_ct734","checked":"Radio_checked_18k9G","green":"Radio_green_3YFHM","red":"Radio_red_dh9Q-"};